import React, { useState } from 'react';
import { login, signup, logout, fetchAPI, AUTH_API_URL } from 'shared/api';

const LoginForm = ({ setToken }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [gstNo, setGstNo] = useState('');
  const [addressLine1, setAddressLine1] = useState('');
  const [addressLine2, setAddressLine2] = useState('');
  const [pinCode, setPinCode] = useState('');
  const [state, setState] = useState('');
  const [fssaiRegNo, setFssaiRegNo] = useState('');
  const [isSignup, setIsSignup] = useState(false);
  const [error, setError] = useState('');
  const [token, setLocalToken] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isSignup) {
        const result = await signup({
          name,
          email,
          password,
          phone,
          gstNo,
          addressLine1,
          addressLine2,
          pinCode,
          state,
          fssaiRegNo
        });
        setError('');
        setIsSignup(false); // Switch to login view after registration
      } else {
        // login API should return { access_token, user }
        const response = await fetchAPI('/auth/login', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, password })
        }, AUTH_API_URL);
        const data = await response.json();
        if (!response.ok) throw new Error(data.error?.message || 'Login failed');
        setLocalToken(data.access_token);
        setToken(data.access_token, data.user);
        setError('');
      }
    } catch (err) {
      // Handle unverified email error
      if (
        err &&
        (err.message === '[object Object]' ||
          (typeof err.message === 'object' && err.message !== null))
      ) {
        setError('Kindly, verify your email first!');
      } else if (
        err &&
        err.message &&
        (err.message.includes('Email not confirmed') || err.message.includes('INVALID_CREDENTIALS'))
      ) {
        setError('Kindly, verify your email first!');
      } else {
        setError(err.message || 'Login failed');
      }
    }
  };

  const handleLogout = async () => {
    try {
      await logout(token);
      setLocalToken('');
      setToken('');
      setError('');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="max-w-md mx-auto p-4 bg-white shadow-md rounded">
      <h2 className="text-2xl font-bold mb-4">{isSignup ? 'Sign Up' : 'Login'}</h2>
      <form onSubmit={handleSubmit}>
        {isSignup && (
          <>
            <div className="mb-4">
              <label className="block text-sm font-medium">Name</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full p-2 border rounded"
                required={isSignup}
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium">Phone</label>
              <input
                type="text"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="w-full p-2 border rounded"
                required={isSignup}
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium">GST No.</label>
              <input
                type="text"
                value={gstNo}
                onChange={(e) => setGstNo(e.target.value)}
                className="w-full p-2 border rounded"
                required={isSignup}
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium">Address Line 1</label>
              <input
                type="text"
                value={addressLine1}
                onChange={(e) => setAddressLine1(e.target.value)}
                className="w-full p-2 border rounded"
                required={isSignup}
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium">Address Line 2</label>
              <input
                type="text"
                value={addressLine2}
                onChange={(e) => setAddressLine2(e.target.value)}
                className="w-full p-2 border rounded"
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium">PIN Code</label>
              <input
                type="text"
                value={pinCode}
                onChange={(e) => setPinCode(e.target.value)}
                className="w-full p-2 border rounded"
                required={isSignup}
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium">State</label>
              <input
                type="text"
                value={state}
                onChange={(e) => setState(e.target.value)}
                className="w-full p-2 border rounded"
                required={isSignup}
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium">FSSAI Registration Number</label>
              <input
                type="text"
                value={fssaiRegNo}
                onChange={(e) => setFssaiRegNo(e.target.value)}
                className="w-full p-2 border rounded"
                required={isSignup}
              />
            </div>
          </>
        )}
        <div className="mb-4">
          <label className="block text-sm font-medium">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-2 border rounded"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-2 border rounded"
            required
          />
        </div>
        {error && <p className="text-red-500">{error}</p>}
        <button type="submit" className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600">
          {isSignup ? 'Sign Up' : 'Login'}
        </button>
        <button
          type="button"
          onClick={() => setIsSignup(!isSignup)}
          className="mt-2 text-blue-500 hover:underline"
        >
          {isSignup ? 'Switch to Login' : 'Switch to Sign Up'}
        </button>
        {token && (
          <button
            type="button"
            onClick={handleLogout}
            className="mt-2 w-full bg-red-500 text-white p-2 rounded hover:bg-red-600"
          >
            Logout
          </button>
        )}
      </form>
    </div>
  );
};

export default LoginForm;